export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-amber-400 to-yellow-600 flex items-center justify-center">
                <i className="ri-car-line text-3xl text-white"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-white">
                  REGAL
                </span>
                <span className="text-sm font-semibold tracking-wider text-amber-400">
                  SPRINTER
                </span>
              </div>
            </div>
            <p className="text-base text-gray-400 leading-relaxed max-w-md mb-8">
              Experience the perfect blend of luxury and affordability with Regal Sprinter's premium Mercedes-Benz transportation services throughout Greater Houston. Professional chauffeurs, 24/7 availability, and unmatched comfort.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="w-12 h-12 rounded-full border border-gray-700 hover:border-teal-500 flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-facebook-fill text-xl text-gray-400 group-hover:text-teal-500"></i>
              </a>
              <a href="#" className="w-12 h-12 rounded-full border border-gray-700 hover:border-teal-500 flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-instagram-line text-xl text-gray-400 group-hover:text-teal-500"></i>
              </a>
              <a href="#" className="w-12 h-12 rounded-full border border-gray-700 hover:border-teal-500 flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-linkedin-fill text-xl text-gray-400 group-hover:text-teal-500"></i>
              </a>
              <a href="#" className="w-12 h-12 rounded-full border border-gray-700 hover:border-teal-500 flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-twitter-x-line text-xl text-gray-400 group-hover:text-teal-500"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-widest mb-6">QUICK LINKS</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('fleet')} className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Fleet
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="text-xs font-bold uppercase tracking-widest mb-6">CONTACT</h3>
            <div className="space-y-6">
              <div>
                <div className="text-xs uppercase text-gray-500 mb-2">ADDRESS</div>
                <p className="text-base text-white">
                  3200 Kirby Dr<br />
                  Houston, TX 77098
                </p>
              </div>
              <div>
                <div className="text-xs uppercase text-gray-500 mb-2">PHONE</div>
                <a href="tel:7139996733" className="text-base text-white hover:text-teal-500 transition-colors cursor-pointer">
                  713-999-6733
                </a>
              </div>
              <div>
                <div className="text-xs uppercase text-gray-500 mb-2">HOURS</div>
                <p className="text-base text-white">
                  24/7 Available
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              &copy; 2025 Regal Sprinter. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
